import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SearchFieldDto } from 'src/app/models/search-field-dto';

@Component({
  selector: 'app-filter-tags',
  templateUrl: './filter-tags.component.html',
  styleUrls: ['./filter-tags.component.scss']
})
export class FilterTagsComponent {
  @Input() tagList!: SearchFieldDto[];
  @Output() removeTag = new EventEmitter<SearchFieldDto>();

  onClick(event: Event){    
    event.preventDefault();
    event.stopPropagation();
  }

  onRemove(event: Event, tag: SearchFieldDto){
    event.preventDefault();
    event.stopPropagation();
    this.removeTag.emit(tag)
  }
}
